
    <mat-form-field appearance="outline" [style.width]="width" subscriptSizing="dynamic"
                    [class.df-invalid]="showError">
      <mat-label *ngIf="label">{{ label }}</mat-label>
      <input #native matInput [type]="mode === 'datetime' ? 'datetime-local' : 'date'"
             [value]="value ?? ''" [disabled]="disabled"
             [attr.min]="minStr" [attr.max]="maxStr"
             (input)="onInput($event)" (blur)="onTouched()">
      <button matSuffix mat-icon-button type="button" [disabled]="disabled" tabindex="-1"
              [attr.aria-label]="mode === 'datetime' ? 'Open date and time picker' : 'Open calendar'"
              (click)="openPicker(native)">
        <br-icon>{{ mode === 'datetime' ? 'event' : 'calendar_today' }}</br-icon>
      </button>
    </mat-form-field>
    <div class="df-error" *ngIf="showError">{{ errorText }}</div>
